/**
 * Created by mykurisu on 2017/12/6.
 */
import React from 'react'
import axios from 'axios'
import {Toast, Mask} from 'react-weui'
import {connect} from 'react-redux'
import { Link, browserHistory } from 'react-router'
import CountDown from '../../../../components/activity/couponSPA/CountDown'
import {renderMoney, isLZWKAPP, TimeStream, randomArr, isIos} from '../../../../utils'
import {avatar_list} from '../../../../utils/avatar_list'
import Item from '../CouponItem'
import AnimationItem from '../AnimationItem'
import config, { prodConfig } from '../../../../config'
import '../../../../css/page/CouponSPA.css'
import headerLuckImg from '../../../../images/activity/couponspa/header-luck.png'
import spaBannerImg from '../../../../images/activity/couponspa/spa-banner.png'
// 测试用的inviter_id
// const inviters = ['36266813', '36266814', '36266815', '36266816', '36266817', '36266818', '36266819']
const inviters = ['44814268', '44006949', '44814193', '44318813', '44814310', '44814368', '44814415', '44814460', '45269110', '46717336', '44814415', '44814460', '50005617']

class CouponV7 extends React.Component {

    constructor(props) {
        super(props)
        const bagId = +props.location.query.bagid
        //如果bagId>14!==19去另一种券包页
        if (bagId > 14 && bagId!==27 && bagId!==22 && !isLZWKAPP() && bagId !== 19) {
            location.assign(`/specials/activity/coupon_timeline?bag_id=${bagId}&inviter_id=${this.getInviterId()}`)
        }
        this.isNewPeople = !!props.location.query.is_new_people
        this.version = props.location.query.version   //增加版本号作为迭代
        this.state = {
            beginShowTime: false,
            channels: [],
            isInit: false,
            is_join: false,
            originIsJoin: false,

            remainder_number: 0,
            used_channels: [],
            end_time: '',
            isPending: false,
            coupon_number: 0,
            price: 0,
            redpacketsPos: this.redpacketsPos,
            isZoomIn: false,
            isRedpacketExchanging: true,
            isFirstJoin: false,
            isPopRedpacketDialog: +props.location.query.pop_card === 1,

            wishCardAvatar: '',
            wishCardImg: '',
            wishCardText: '',
            totalCouponPrice:0,
            //fake_content
            animation_content: '',
            prizeCanShowChannel: false,
            hasUseAllCoupon: false, //是否用完所有红包
        }
    }

    componentDidMount() {
        let img = new Image(0, 0);
        img.src = headerLuckImg;
        new Image(0, 0).src = spaBannerImg;
        const bagid = this.props.location.query.bagid
        const pop_luckyshare = this.props.location.query.pop_luckyshare
        if (!bagid) {
            return location.assign('/')
        }
        if (+this.props.location.query.pop_card === 1) {
            // this.setRedpacketsPos()
            this.mta('couponspa_wish_card_show')
        }
        if (Number(pop_luckyshare) === 1) {
            this.setState({
                prizeShareShown: true
            })
        }
        this.fetchInfo(bagid)

    }
    componentWillUnmount () {
        this.fake_animation && clearInterval(this.fake_animation);
        this.begin && clearInterval(this.begin);
    }

    mta (payload) {
        this.props.dispatch({ type: 'MTA_CLICK', payload });
    }

    fetchInfo (bagid) {
        const query = this.props.location.query
        let params = +query.pop_card === 1 ? {
            pop_card: query.pop_card,
            bag_inviter_id: query.bag_inviter_id,
            template_id: query.template_id,
            greettext: query.greettext,
        } : {}
        if (query.pop_luckyshare) {
            params.pop_luckyshare = 1
        }
        axios.get(`/api/coupon/weike_active/${bagid}/info`, {
            params: params
        })
            .then(res => {
                const resData = res.data.data
                const originIsJoin = resData.is_join
                if (+query.pop_card === 1) {
                    // resData.is_join = false
                }
                if (!resData.is_join) {
                    this.mta('couponspa_random_rp_show')
                }
                if (res.data.code === 0) {
                    // 过期就闪人
                    if (resData.status === 'deadline') {
                        return location.assign('/')
                    }
                    if (+query.is_auto_receive === 1) {
                        // this.fetchGetCoupon(bagid)
                    }
                    this.mta(`new_coupon_spa_enter_${bagid}`)
                    document.title = resData.title;
                    if (!resData.is_join && !this.props.location.query.get_coupon){
                        this.mta(`new_coupon_spa_btnshow_${bagid}`)
                    }
                    // if (+query.pop_card !== 1) {
                    //     setTimeout(() => {
                    //         this.randomRedpackets()
                    //     }, 300)
                    // }


                    //计算红包总价
                    let canUseTotalPrice = 0;
                    resData.coupons_info.map(v=>(
                        v.used === 0 ? canUseTotalPrice += (renderMoney(v.price) * 100) : '',
                            this.setState({
                                totalCouponPrice :  canUseTotalPrice
                            })
                    ))

                    //计算使用过多少优惠券
                    let hasUsed = []
                    resData.coupons_info.map(v=>(
                        v.used === 1 ? hasUsed.push(v.used) : '',
                            hasUsed.length === resData.coupons_info.length ?
                                this.setState({
                                    hasUseAllCoupon: true
                                })
                                : this.setState({
                                    hasUseAllCoupon: false
                                })
                    ))


                    this.setState({
                        remainder_number: resData.remainder_number,
                        used_channels: resData.used_channels,
                        is_join: resData.is_join,
                        originIsJoin: originIsJoin,
                        end_time: resData.end_time,
                        channels: resData.channels,
                        coupon_number: resData.coupon_number,
                        price: resData.price,
                        isInit: true,
                        wishCardAvatar: resData.inviter_info && resData.inviter_info.account.small_avatar_url,
                        wishCardImg: resData.inviter_info && resData.inviter_info.theme.avatar,
                        wishCardText: resData.inviter_info && resData.inviter_info.greettext,

                        prizeCanShowChannel: resData.is_join,
                        coupons_info: resData.coupons_info,
                    }, () => {
                        if (!this.state.is_join) {
                            this.fetchGetCoupon (bagid)
                        }
                    });
                    this.handleFaker()
                    this.initShareData(resData, bagid)
                }
                else {
                    location.assign('/')
                }
            });
    }
    getInviterId () {
        let from
        const wkFrom = this.props.location.query.wk_from
        from = wkFrom ? wkFrom : this.props.location.query.from
        const queryInviterId = this.props.location.query.inviter_id
        if (queryInviterId) return queryInviterId
        switch (from) {
            case 'back_subscribed':
                return inviters[0]
            case 'back_no_subscribed':
                return inviters[1]
            case 'article':
                return inviters[2]
            case 'app':
                return inviters[3]
            case 'wx_share':
                return inviters[4]
            case 'home':
                return inviters[5]
            case 'schedule':
                return inviters[6]
            case 'card_sharelink':
                return inviters[7]
            case 'sharecard':
                return inviters[8]
            case 'index_gap':
                return inviters[10]
            case 'mywk_gap':
                return inviters[11]
            case 'taxiang':
                return inviters[12]
            default:
                return inviters[9]
        }
    }
    initShareData (data, bagid) {
        let share_info = +bagid === 8 ?{
            share_description : "你有28位好友已领取，就差你了",
            share_icon : "http://static-1253442168.cosgz.myqcloud.com/new_people/%E5%88%86%E4%BA%AB%E5%A4%B4%E5%83%8F%403x.png",
            share_title : "新人报到大礼包",
            share_url : config.MAIN_URL + '/specials/newreports_transfer'
        } : data.share_info
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: share_info.share_title,
                desc: share_info.share_description,
                imgUrl: share_info.share_icon,
                type: 'link',
                link: share_info.share_url,
                is_resell: '1',
                successCallback: () => {
                    this.mta('luckydraw_share_success')
                }
            }
        });
    }
    //自动获取红包
    fetchGetCoupon (bagid) {
        const inviterId = this.getInviterId()
        const {query} = this.props.location;
        let data = new FormData();
        data.append('bag_inviter_id', query.bag_inviter_id || 0);
        axios.post(`/api/coupon/weike_active/${bagid}/receive_coupons/${inviterId}`, data)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        is_join: true,
                        isFirstJoin: true,
                        prizeCanShowChannel: true,
                    })
                    this.handleFaker()
                }
            })
            .catch(err => alert('系统繁忙，请稍后再试'))
    }


    //初始化"买了课程"那个东西浮层
    handleFaker() {
        if (this.fake_animation) {
            return
        }
        let raw_list = avatar_list;
        let result = [];

        let avatar_num = 10;

        for (let i = 0;i < avatar_num;i++){
            let random = Math.floor(Math.random() * (raw_list.length - i));
            result.push(raw_list[random]);
            raw_list[random] = raw_list[raw_list.length - i - 1];
        }

        let list = [
            {img: result[0], time: '3'},
            {img: result[1], time: '4'},
            {img: result[2], time: '5'},
            {img: result[3], time: '6'},
            {img: result[4], time: '6'},
            {img: result[5], time: '7'},
            {img: result[6], time: '8'},
            {img: result[7], time: '8'},
            {img: result[8], time: '9'},
            {img: result[9], time: '9'}
        ];

        let index = -1;

        this.setState({
            animation_content: list[0]
        }, () => {
            index = 0
        });

        this.fake_animation = setInterval(() => {
            if (index === 9){
                index = 0
            }else {
                index = index + 1
            }
            this.setState({
                animation_content: list[index]
            })
        }, 2300)
    }

    onClickWishCard (e) {
        this.mta('couponspa_click_wish_card')
        this.setState({ isPopRedpacketDialog: false })
        // this.setState({ isPopRedpacketDialog: false, isRedpacketExchanging: false }, () => {
        //     this.onClickRedpacket(1, this.props.location.query.bagid)
        // })
    }

    jumpToContent() {
        const redPacketLectureArea = this.refs.redPacketLecture.getBoundingClientRect().top
        window.scrollTo (0, redPacketLectureArea)
    }

    calcBeginTime(time) {
        // console.log(Math.floor(((time * 1000) - Date.parse(new Date())) / 1000 / 3600 / 24))
        const beginTime = new Date(time * 1000 - (3600 * 24 * 1000 * 7))
        const end_Time = new Date(time * 1000)
        const returnBeginTime = (beginTime.getMonth() + 1) +'.'+ beginTime.getDate()
        const returnEndTime = (end_Time.getMonth() + 1)+'.'+ end_Time.getDate()
        return `${returnBeginTime}~${returnEndTime}`
    }

    render() {
        const {
            channels, used_channels, end_time, is_join, isFirstJoin, isPopRedpacketDialog,
            remainder_number, coupon_number, price, redpacketsPos, isInit, wishCardAvatar,
            wishCardImg, wishCardText, isRedpacketExchanging, prizeList, prizeActivedId,coupons_info
        } = this.state

        const ActivityBarForNewParams = {
            remainder_number,price
        }
        const bagid = this.props.location.query.bagid
        const isAutoReceive = +this.props.location.query.is_auto_receive === 1
        const inviterId = this.getInviterId()
        const iosAppLzb = Number(this.props.location.query.bagid) === 13 && isIos() && isLZWKAPP()

        if (!isInit) {
            return (
                <div className="wk-page couponspa-no-init">
                    <Toast show={true} icon={'loading'} />
                </div>
            )
        }

        // 优惠券页
        return (
            <div className="coupon_v7b">
                <div className="activity__couponspa">


                    {/* 购买动画 xxx买了课程动画 */}
                    {this.state.prizeCanShowChannel &&
                    <AnimationItem content={this.state.animation_content}/>
                    }

                    <Toast show={this.state.isPending} icon={'loading'} />

                    {/* 抽到红包后才显示以下内容 */}
                    {this.state.prizeCanShowChannel &&
                    <div className="prize__container">
                        {/*当有券的时候显示 */}
                        {/*<img src="https://static-1253442168.image.myqcloud.com/picture/8173011_2a7cdfc02fcf67f52548267cdd89fb7a.jpg" alt=""/>*/}
                        <div className="coupon_newBanner" onClick={() => this.jumpToContent()}>
                            <div style={{position: 'relative', top: 30, margin: '0 auto', marginBottom: 30}}>
                                <img style={{width: '80%', position: 'relative', margin: '0 auto', display: 'block'}} src="https://static-1253442168.image.myqcloud.com/picture/10490565_bba86ba1f73422c91887e1cdd775541e.jpg" alt=""/>
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                     <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_a5c3fc341777981f66f285949dd42809.jpg" alt=""/>
                                     <p className="timeSet" style={{fontSize: 14 ,color: '#fff', position: 'absolute', marginLeft: '-2%'}}>红包有效期: {this.calcBeginTime(this.state.end_time)}</p>
                                </div>
                            </div>
                            {remainder_number!==0 ?
                                <div className="coupon_big_title">
                                    {this.state.isFirstJoin ?
                                        `恭喜你！获得${this.state.totalCouponPrice}元微课红包`
                                        :
                                        `你有${this.state.totalCouponPrice}元红包未使用`
                                    }

                                </div>
                                :
                                <div className="coupon_big_title coupon_big_title_ifNoCoupon">
                                    哇塞，你的红包已用完<br/>去其他活动页逛逛吧！
                                </div>
                            }

                            {remainder_number === 0 &&
                            <div className="BoutiqueBtn">
                                <span onClick={()=>window.location.assign(`${prodConfig.MAIN_URL}/activity/seckill?inviter_id=61329186`)}>精品低价专区</span>
                            </div>
                            }

                            <div className="coupon_show_area" style={remainder_number==0  ? { paddingTop: 45 } : null }>
                                {remainder_number !== 0  &&
                                <div className="coupon_show_area_list">
                                    {coupons_info.map(v=>(
                                        <div key={v.id[0]} className="coupon_show_area_info">
                                            <span className={v.used===1 && 'ifUse' }>
                                                <i>¥</i><p>{ renderMoney(v.price) * 100}</p>
                                            </span>
                                            <img src={v.used===1 ?
                                                'https://static-1253442168.image.myqcloud.com/picture/8173011_0ac8a39f884c38869395751206f3373b.jpg' :
                                                'https://static-1253442168.image.myqcloud.com/picture/8173011_324bbe1517947e0c420fd4d69425021e.jpg'
                                            } alt=""/>
                                        </div>
                                    ))}
                                </div>
                                }
                                <div className="roundbg"><img src="https://static-1253442168.image.myqcloud.com/picture/8173011_02788ea0317b8a603296a6f294caa2d3.jpg" alt=""/></div>
                            </div>

                        </div>



                        <div className="couponspa__showTime" ref="redPacketLecture">
                            <img className="slogan_xjq" src={this.version === '7C' ?
                                "https://static-1253442168.image.myqcloud.com/picture/8173011_da40e0f163db5aa5a8a60c7f7e2736cd.jpg"
                                :
                                "https://static-1253442168.image.myqcloud.com/picture/8173011_374b0d8eaa3bbf0f866b451c0f663ccb.jpg-picmsg420"
                            } alt="" onClick={() => this.jumpToContent()}/>

                            { this.version === '7C' &&  <CountDown endTime={this.state.end_time} /> }

                            {/*课程列表*/}
                            <div className="coupons-wrap">
                                <div className="couponspa__list">
                                    {
                                        channels.map(item => {
                                            if (used_channels.indexOf(item.id) < 0) {
                                                return (
                                                    <Item
                                                        key={item.id}
                                                        content={item}
                                                        dispatch={this.props.dispatch}
                                                        is_join={is_join}
                                                        inviterId={inviterId}
                                                        price={price}
                                                        isNewPeople={false}
                                                    />
                                                )
                                            }
                                        })
                                    }
                                </div>

                                {
                                    remainder_number > 0 && (
                                        <div className="tip">
                                            * 本活动页优惠专栏不定期更新，看上了请及时购买
                                        </div>
                                    )
                                }


                                {
                                    used_channels.length > 0 && (
                                        <div className="more" style={{paddingTop: remainder_number === 0 ? '0' : '15px'}}>
                                            <Link to='/account/bought'>{'>> 查看购买记录 <<'}</Link>
                                        </div>
                                    )
                                }

                            </div>

                        </div>
                    </div>
                    }
                </div>
            </div>
        )
    }
}


export default connect((state) => ({}))(CouponV7)



// WEBPACK FOOTER //
// ./src/pages/ActivityPage/Coupon/CouponVersion/CouponV7.js